import React, { useState } from 'react';

import { Button, Group, Title } from '@mantine/core';
import PageHeader from 'components/PageHeader';
import { useAuth } from 'context/auth-context';
import { useNavigate } from 'react-router-dom';
import { Flow } from 'types';

import FlowsTableContainer from './components/FlowsTableContainer';

const Flows = (): JSX.Element => {
  const { hasPerm } = useAuth();
  const flowsPerm = hasPerm('FlowMutate');
  const navigate = useNavigate();

  const [tableData, setTableData] = useState<Flow[]>([]);

  return (
    <>
      <PageHeader>
        <Group position='apart' align='center' noWrap>
          <Title order={1} size='h1'>
            Flows
          </Title>
          <Button color='kiloBlue' onClick={() => navigate('/flow-builder')} disabled={!flowsPerm}>
            New Flow
          </Button>
        </Group>
      </PageHeader>
      <FlowsTableContainer tableData={tableData} setTableData={setTableData} permission={flowsPerm} />
    </>
  );
};

export default Flows;
